import React, { useEffect } from 'react';

const previews = {
  'exam-plans': React.lazy(() => import('./ExamPlanList')),
  'exam-plan-details': React.lazy(() => import('./ExamPlanDetail')),
};

export default function SubscriptionStaticPreview({ page }) {
  useEffect(() => {
    document.body.classList.add('subscription-ui-preview');
    return () => document.body.classList.remove('subscription-ui-preview');
  }, []);

  const Page = previews[page];
  return (
    <React.Suspense fallback={<div role="status">Loading preview…</div>}>
      <Page />
    </React.Suspense>
  );
}
